var _style, _path, _path2, _circle, _circle2, _circle3, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaiver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "waiver_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#35a4dd",
    d: "M927.9 586.4c-21.2-21.2-49.5-32.9-79.6-32.9-30.1 0-58.4 11.7-79.6 32.9l-222.5 222c-3.7 3.7-6.4 8.2-7.9 13.2l-48.5 159.5c-3.3 11-.4 23 7.6 31.2 5.9 6 14.1 9.5 22.6 9.5 2.8 0 5.7-.4 8.4-1.1L692 975.3c5.2-1.4 10-4.2 13.9-8.1L928 745.6c43.8-43.9 43.8-115.3-.1-159.2zM818.1 766.1l-149.3 149-1.7 1.7-2.3.6-82.3 22.8-15.8 4.4 4.8-15.7 24.1-79.3.7-2.2 1.6-1.6L748 696l6.4-6.3 6.4 6.4 57.3 57.3 6.4 6.4-6.4 6.3zm65.2-65.1l-7.9 7.8-6.4 6.4-6.4-6.4-57.3-57.3-6.4-6.4 6.4-6.4 7.8-7.8c9.3-9.3 21.8-14.5 35-14.5s25.7 5.1 35 14.5c19.5 19.4 19.5 50.8.2 70.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#35a4dd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 65,
    d: "M807.1 433.5V35H105.2v951h267.1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 239.4,
    cy: 276.9,
    r: 32.6,
    fill: "#F9AF17"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 239.4,
    cy: 439,
    r: 32.6,
    fill: "#F9AF17"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 239.4,
    cy: 601.2,
    r: 32.6,
    fill: "#F9AF17"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f9af17",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 65,
    d: "M335.7 280.3h337.2M334.3 439h338.6M335.7 601.2h191.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaiver);
export default ForwardRef;